import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from './contexts/ThemeContext'; // Importuj useTheme

import aiCreatorImage from '../images/ai-creator.png';
import filesImageLight from '../images/files.jpg'; // Obrazek dla jasnego motywu
import filesImageDark from '../images/filesdark2.png'; // Obrazek dla ciemnego motywu

const HomePage = () => {
    const { theme } = useTheme(); // Pobierz aktualny motyw z kontekstu

    // Wybierz odpowiedni obrazek na podstawie motywu
    const currentFilesImage = theme === 'light' ? filesImageLight : filesImageDark;

    return (
        <div>
            <div className="container home-container">
                <div className="home-cards-container">
                    <Link to="/exam/create" className="home-action-card">
                        <div className="card-icon">
                            <img
                                src={aiCreatorImage}
                                alt="Kreator Egzaminów Próbnych"
                                style={{ width: '150px', height: '150px' }} // Dodajemy styl tutaj
                            />
                        </div>
                        <h3>Kreator Egzaminów Próbnych</h3>
                        <p>Wprowadź zasoby, na bazie których Sztuczna Inteligencja sprawdzi Twoją wiedzę</p>
                    </Link>

                    <Link to="/my-exams" className="home-action-card">
                        <div className="card-icon">
                            <img
                                src={currentFilesImage} // Użyj wybranego obrazka
                                alt="Moje Egzaminy"
                                style={{ width: '180px', height: '180px' }} // Dodajemy styl tutaj
                            />
                        </div>
                        <h3>Moje Egzaminy</h3>
                        <p>Przeglądaj i zarządzaj swoimi egzaminami.</p>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default HomePage;
